import { render } from "./Group456.vue?vue&type=template&id=0f1770cd"
import script from "./Group456.vue?vue&type=script&lang=js"
export * from "./Group456.vue?vue&type=script&lang=js"

import "./Group456.vue?vue&type=style&index=0&id=0f1770cd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__